"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DECISIONS_CLIENT_RETRY_MIN_REMAINING_MS = exports.DECISIONS_CLIENT_RETRY_BACKOFF_MS = void 0;
exports.isRetryableDecisionsFailure = isRetryableDecisionsFailure;
exports.shouldRetryDecisionsHttp = shouldRetryDecisionsHttp;
exports.fetchWithDecisionsRetry = fetchWithDecisionsRetry;
exports.DECISIONS_CLIENT_RETRY_BACKOFF_MS = 150;
exports.DECISIONS_CLIENT_RETRY_MIN_REMAINING_MS = 800;
function hasOverloadCode(errorText) {
    const text = (errorText ?? '').trim();
    if (!text)
        return false;
    try {
        const parsed = JSON.parse(text);
        return parsed?.code === 'overload';
    }
    catch {
        return false;
    }
}
/** 502/503/504 or an explicit `{ code: 'overload' }`. Not a 500 config miss or a 400 that merely mentions overload. */
function isRetryableDecisionsFailure(status, errorText) {
    if (status === 502 || status === 503 || status === 504)
        return true;
    if (status != null)
        return false;
    return hasOverloadCode(errorText);
}
/**
 * Retry the Cloud Function POST once when the 4 s abort budget still has ≥800 ms.
 * A slow ~3.5 s 503 is not retried (remaining ≈480 ms). The server already retries
 * OpenAI 503 once, so a fast overload can become up to 4 OpenAI calls (2 server × 2 client).
 */
function shouldRetryDecisionsHttp(input) {
    if (input.alreadyRetried)
        return false;
    if (input.remainingMs < exports.DECISIONS_CLIENT_RETRY_MIN_REMAINING_MS)
        return false;
    return isRetryableDecisionsFailure(input.status, input.errorText);
}
function defaultDecisionsRetrySleep(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}
/** One extra Cloud Function POST when the first response is a fast 502/503/504. */
async function fetchWithDecisionsRetry(doFetch, options) {
    const first = await doFetch();
    if (first.ok)
        return first;
    const errorText = await first.clone().text().catch(() => '');
    if (!shouldRetryDecisionsHttp({
        status: first.status,
        errorText,
        remainingMs: options?.remainingMs?.() ?? Number.POSITIVE_INFINITY,
    })) {
        return first;
    }
    await (options?.sleep ?? defaultDecisionsRetrySleep)(exports.DECISIONS_CLIENT_RETRY_BACKOFF_MS);
    if (options?.signal?.aborted)
        return first;
    return doFetch();
}
